import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/case-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/CaseForm';
import { ICase } from 'src/types/case';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { routes } from 'src/navigation';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IOrder } from '../../../../../../types/order';
import { IProvider } from '../../../../../../types/provider';
import { QueryParams } from '../../../../../../types/grid';

import { IServiceLocation } from '../../../../../../types/service-locations';
import { IServiceType } from '../../../../../../types/service-types';
import OrderEnum from '../../../../../../enumerables/order-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import { toFormValues } from '../../../Cases/helpers';
import CaseEnum from '../../../../../../enumerables/case-enum';
import { Link } from 'react-router-dom';
import Router from '../../../../../../navigation/router';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';
import { getCheckCases, resetDouble } from '../../../../../../store/actions/case-actions';
import { useDispatch } from 'react-redux';

export interface StateProps {
    caseEnt: ICase | null;
    inProgress: boolean;
    inProgressProvider: boolean;
    files: any;
    students: SelectObject[];
    vendors: SelectObject[];
    districts: SelectObject[];
    orders: Paginated<IOrder>;
    providers: Paginated<IProvider>;
    serviceLocations: Paginated<IServiceLocation>;
    serviceTypes: Paginated<IServiceType>;
    serviceTypeProviders: SelectObject[];
    valuesForm: { [key: string]: any };
    caseTypeValue: string | number;
    serviceTypeProviderValue: string;
    invoiceSignerValue: string | number;
    statusItemValue: string | number;
    orderValue: string | number;
    orderTypes: SelectObject[];
    caseTypes: SelectObject[];
    orderTypeValue: string | number;
    isDouble: any;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, files: any) => void;
    removeFile: (id: string | number) => void;
    getOrders: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const CaseEditScreen: FC<Props> = (props: Props) => {
    const [isOrdersFetch, setOrdersFethed] = useState(false);
    const [dataSaveModal, setSaveModal] = useState(false);
    const dispatch = useDispatch();
    const {
        caseEnt,
        match: {
            params: { id },
        },
        getFiles,
        files,
        inProgressProvider,
        addFiles,
        inProgress,
        removeFile,
        getData,
    } = props;

    useEffect(() => {
        if (!caseEnt || caseEnt.id !== id) {
            getData(id);
            getFiles(id);
        }
        // eslint-disable-next-line
    }, [getFiles, getData, id]);
    useEffect(() => {
        setOrdersFethed(false);
    }, [props.orderTypeValue, props.caseTypeValue, props.orderValue]);
    useEffect(() => {
        //  props.getOrders(props.orderTypeValue);
        // eslint-disable-next-line
        if (!isOrdersFetch && props.orderTypeValue && props.caseEnt) {
            setOrdersFethed(true);
            props.getOrders({
                page: 1,
                filters: {
                    id: props.caseEnt?.orderEntity?.id,
                    type: props.orderTypeValue,
                },
                itemsPerPage: 80,
            });
        }
        // eslint-disable-next-line
    }, [props.orderTypeValue, props.caseTypeValue, props.orderValue, getData]);

    useEffect(() => {
        props.getServiceLocations({
            page: 1,

            itemsPerPage: 9000,
        });
        props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });
        props.getStudents({
            page: 1,
            itemsPerPage: 9000,
        });
        props.getServiceTypes({
            page: 1,
            filters: {
                // orderType: props.orderTypeValue,
            },
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, []);

    const handeAdd = async (files: any) => {
        await addFiles(id, files);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };

    const handleCheck = (event: any) => {

    };

    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);

    const AuthorizationSources = OrderEnum ? OrderEnum.getEnum('AuthorizationSource') : {};
    const valuesAuthorizationSources: SelectObject[] = getValFromEnum(AuthorizationSources);

    const MinPerUnit = CaseEnum ? CaseEnum.getEnum('MinPerUnit') : {};
    const minPerUnitValues: SelectObject[] = getValFromEnum(MinPerUnit);

    const InvoiceSigner = CaseEnum ? CaseEnum.getEnum('InvoiceSigner') : {};
    const invoiceSignerValues: SelectObject[] = getValFromEnum(InvoiceSigner);

    const ServiceTypeProvider = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const serviceTypeProviderValues: SelectObject[] = getValFromEnum(ServiceTypeProvider);

    const CaseStatus = CaseEnum ? CaseEnum.getEnum('CaseStatus') : {};
    const statusValues: SelectObject[] = getValFromEnum(CaseStatus);

    const ServiceTypeProviders = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const valuesServiceTypeProviders: SelectObject[] = getValFromEnum(ServiceTypeProviders);

    const infoEntity = {
        caseAuthorizationValue: '',
        caseNumberValue: '',
        caseAuthorizationSourceValue: '',
        caseNumberValidityValue: '',
        AllocatedHoursPerValue: '',
        NumberHoursAllocatedValue: '',
        MoneyAllocatedValue: '',
        ServiceTypeValue: '',
        studentFullNameValue: '',
        serviceTypeProviderValue: '',
        studentId: '',
        ServiceTypeId: '',
        caseNumberValidityFrom: '',
        caseNumberValidityTo: '',
    };

    const OrderValues: SelectObject[] = [];

    props.orders.list.forEach((it: Partial<IOrder>) => {
        OrderValues.push({ value: it.id, label: `${it.name}` });
        if (props.orderValue === it.id) {
            infoEntity.caseAuthorizationValue = it.authorizationDate
                ? `${changeToZeroMoment(it.authorizationDate, 'MMM D, YYYY')}`
                : '';
            infoEntity.caseNumberValue = `${it?.caseNumber}`;
            const valueSource = valuesAuthorizationSources.find((itSourse) => {
                return itSourse.value === it.authorizationSource;
            });
            const valueServiceTypeProvider = valuesServiceTypeProviders.find((itSourse) => {
                return itSourse.value === it.serviceTypeProvider;
            });
            infoEntity.caseAuthorizationSourceValue = valueSource ? `${valueSource?.label}` : '';

            infoEntity.serviceTypeProviderValue = valueServiceTypeProvider
                    ? `${valueServiceTypeProvider?.label}`
                    : '';

            infoEntity.caseNumberValidityValue = `${changeToZeroMoment(
                it.caseNumberValidityFrom,
                'MMM D, YYYY',
            )} - ${changeToZeroMoment(it.caseNumberValidityTo, 'MMM D, YYYY')}`;
            const valuePeriod = valuesAllocatedPeriod.find((itPeriod) => {
                return itPeriod.value === it.allocatedPeriod;
            });
            infoEntity.caseNumberValidityFrom = `${it.caseNumberValidityFrom}`;
            infoEntity.caseNumberValidityTo = `${it.caseNumberValidityTo}`;

            infoEntity.AllocatedHoursPerValue = valuePeriod ? `${valuePeriod?.label}` : '';
            infoEntity.NumberHoursAllocatedValue = `${it?.allocatedHours}`;
            infoEntity.MoneyAllocatedValue = `${it?.allocatedMoney}`;

            const labelArr = [];
            if (it?.serviceType?.title) {
                labelArr.push(it?.serviceType?.title);
            }
            if (it?.serviceType?.cpt) {
                labelArr.push(`CPT: [${it?.serviceType?.cpt}]`);
            }
            const label = labelArr.join(', ');

            infoEntity.ServiceTypeValue = label;

            // ServiceTypeValue = `${it?.serviceType ? serviceTypes[${it.serviceType] : ''}`;

            infoEntity.studentFullNameValue = it?.student ? `${it.student?.firstName} ${it.student?.lastName}` : '';
            infoEntity.studentId = it?.student?.id ? `${it?.student?.id}` : '';

            infoEntity.ServiceTypeId = it?.serviceType?.id ? it?.serviceType?.id : '';
        }
    });

    if (props.caseEnt && props.caseEnt.orderEntity && !infoEntity.caseNumberValidityFrom) {
        infoEntity.caseNumberValidityFrom = `${props.caseEnt.orderEntity.caseNumberValidityFrom}`;
    }
    if (props.caseEnt && props.caseEnt.orderEntity && !infoEntity.caseNumberValidityTo) {
        infoEntity.caseNumberValidityTo = `${props.caseEnt.orderEntity.caseNumberValidityTo}`;

        infoEntity.caseNumberValidityValue = `${changeToZeroMoment(
            infoEntity.caseNumberValidityFrom,
            'MMM D, YYYY',
        )} - ${changeToZeroMoment(infoEntity.caseNumberValidityTo, 'MMM D, YYYY')}`;

        infoEntity.caseNumberValue = `${props.caseEnt.caseNumber}`;
        const valueSource = valuesAuthorizationSources.find((itSourse) => {
            return itSourse.value === props.caseEnt?.orderEntity.authorizationSource;
        });
        infoEntity.caseAuthorizationSourceValue = valueSource ? `${valueSource?.label}` : '';

        const valuePeriod = valuesAllocatedPeriod.find((itPeriod) => {
            return itPeriod.value === props.caseEnt?.orderEntity.allocatedPeriod;
        });

        infoEntity.caseAuthorizationValue = props.caseEnt?.orderEntity.authorizationDate
            ? `${changeToZeroMoment(props.caseEnt?.orderEntity.authorizationDate, 'MMM D, YYYY')}`
            : '';

        infoEntity.AllocatedHoursPerValue = valuePeriod ? `${valuePeriod?.label}` : '';
        infoEntity.NumberHoursAllocatedValue = `${props.caseEnt?.orderEntity?.allocatedHours}`;
        infoEntity.MoneyAllocatedValue = `${props.caseEnt?.orderEntity?.allocatedMoney}`;
    }
    if (props.caseEnt && props.caseEnt.orderEntity && !infoEntity.studentId) {
        infoEntity.studentId = props.caseEnt.orderEntity.student?.id ? `${props.caseEnt.orderEntity.student?.id}` : '';
        infoEntity.studentFullNameValue = props.caseEnt.orderEntity.student
            ? `${props.caseEnt.orderEntity.student?.firstName} ${props.caseEnt.orderEntity.student?.lastName}`
            : '';
    }
    if (props.caseEnt && props.caseEnt.orderEntity && !infoEntity.ServiceTypeId) {
        infoEntity.ServiceTypeId = props.caseEnt.orderEntity?.serviceType?.id
            ? props.caseEnt.orderEntity?.serviceType?.id
            : '';
        const labelArr = [];
        if (props.caseEnt.orderEntity?.serviceType?.title) {
            labelArr.push(props.caseEnt.orderEntity?.serviceType?.title);
        }
        if (props.caseEnt.orderEntity?.serviceType?.cpt) {
            labelArr.push(`CPT: [${props.caseEnt.orderEntity?.serviceType?.cpt}]`);
        }
        const label = labelArr.join(', ');
        infoEntity.ServiceTypeValue = label;
    }

    const caseValues = toFormValues(props.caseEnt ? props.caseEnt : {}, {
        AllocatedPeriod: valuesAllocatedPeriod,
        AuthorizationSource: valuesAuthorizationSources,
        OrderTypes: props.orderTypes,
        statusValues: statusValues,
        invoiceSignerValues: invoiceSignerValues,
        serviceTypeProviderValues: serviceTypeProviderValues,
        minPerUnitValues: minPerUnitValues,
        serviceLocation: props.serviceLocations.list,
        serviceTypes: props.serviceTypes,
        caseTypes: props.caseTypes,
    });
    let caseNumberValidityFrom: any = infoEntity.caseNumberValidityFrom;
    let caseNumberValidityTo: any = infoEntity.caseNumberValidityTo;
    if (+props.caseTypeValue !== 1) {
        caseNumberValidityFrom = caseValues.caseNumberValidityFrom;
        caseNumberValidityTo = caseValues.caseNumberValidityTo;
    }
    let numberOfHoursBilled = '';
    if (props.valuesForm) {
        const externalRatePerHour = props.valuesForm.externalRatePerHour;
        const externalEvalHourlyRate = props.valuesForm.externalEvalHourlyRate;
        numberOfHoursBilled = `${(+externalRatePerHour / +externalEvalHourlyRate).toFixed(1)}`;
    }
    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'CASES', path: Router.generate(routes.CASES_LIST, { status: '' }) },
                    { name: `EDIT ${caseEnt?.id ? caseEnt?.id : ''}`, path: '' },
                ]}
            />
            <div className="d-flex justify-content-center mb-4 flex-row">
                <h3 className={classNames(`${styles.activeTab}  pb-1 mr-5`)}>
                    <Link to={Router.generate(routes.CASE_EDIT, { id })}>Step 1</Link>
                </h3>
                <h3>
                    <Link to={Router.generate(routes.CASE_CALENDAR, { id })}>Step 2</Link>
                </h3>
            </div>
            <div className={classNames(styles.editWrap)}>
                {inProgress || inProgressProvider ? <Loader /> : !caseEnt ? <div></div> : null}
                <Form
                    orderTypes={props.orderTypes}
                    caseTypes={props.caseTypes}
                    infoEntity={infoEntity}
                    OrderValues={OrderValues}
                    serviceLocations={props.serviceLocations.list}
                    orderTypeValue={props.orderTypeValue}
                    statusItemValue={props.statusItemValue}
                    caseTypeValue={props.caseTypeValue}
                    serviceTypeProviderValue={props.serviceTypeProviderValue}
                    invoiceSignerValue={props.invoiceSignerValue}
                    minPerUnitValues={minPerUnitValues}
                    vendors={props.vendors}
                    districts={props.districts}
                    serviceTypeProviders={props.serviceTypeProviders}
                    statusValues={statusValues}
                    invoiceSignerValues={invoiceSignerValues}
                    serviceTypeProviderValues={serviceTypeProviderValues}
                    files={files ? files : []}
                    serviceTypes={props.serviceTypes.list}
                    providers={props.providers.list}
                    students={props.students}
                    numberOfHoursBilled={!!+numberOfHoursBilled ? numberOfHoursBilled : '0'}
                    setFiles={handeAdd}
                    status={caseEnt?.status}
                    initialValues={{
                        ...caseValues,
                        //    ...props.valuesForm,
                        serviceType: infoEntity.ServiceTypeId,
                        student: infoEntity.studentId,
                        caseNumberValidityFrom,
                        caseNumberValidityTo,
                    }}
                    valuesForm={props.valuesForm}
                    removeFile={(id) => handeRemove(id)}
                    dataSaveModal={dataSaveModal}
                    setSaveModal={setSaveModal}
                    handleCheck={handleCheck}
                    isDouble={props.isDouble}
                    resetDouble={() =>
                        dispatch(resetDouble())
                    }
                />
            </div>
        </RoleLayout>
    );
};
export default CaseEditScreen;
